export default class EventWrapper {
	constructor(action, context) {
		this.action = action;
		this.context = context;
	}
}
